// extracted by mini-css-extract-plugin
export var page = "pageEnd-module--page--Z0E4p";
export var box1 = "pageEnd-module--box1--To5o7";
export var box2 = "pageEnd-module--box2--YUNtE";
export var box3 = "pageEnd-module--box3--tq65T";
export var replayBtn = "pageEnd-module--replayBtn--sMTJi";
export var buttons = "pageEnd-module--buttons--WOIV1";